<template>
    <div class="File-upload">
        <input
            :id="name"
            ref="input"
            type="file"
            :name="file && name"
            class="sr-only"
            accept=".jfif, .jp2, .jpx, .jpg, .jpeg, .jpe, .tiff, .tif, .png, .gif, .bmp, .webp, .ppm, .pgm, .pnm, .pfm, .pam, .svg, .pdf"
            data-file-limit="1"
            :required="required"
            @change="updateUi"
        />

        <div
            class="flex items-center pl-6"
            style="border-width: 1px;"
            :style="{ borderColor: error ? '#e62e43' : '#e5ecf1' }"
        >
            <span v-if="file" class="flex-grow text-sm text-blue-500">{{ fileName }}</span>
            <span v-else class="flex-grow text-sm text-grey-500">No file chosen</span>

            <label
                v-if="!file"
                :for="name"
                class="flex items-center justify-center h-12 px-5 py-3 font-bold text-blue-500 cursor-pointer File-upload__button"
                :class="{ 'bg-grey-100': !file }"
            >
                Choose file
            </label>
            <div
                v-else
                class="flex items-center justify-center w-12 h-12 cursor-pointer"
                @click="reset"
            >
                <svg
                    class="w-3 h-3"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                    role="img"
                    focusable="false"
                    aria-label="File Upload"
                >
                    <path
                        fill="#647187"
                        d="M10 8.586L2.929 1.515 1.515 2.929 8.586 10l-7.071 7.071 1.414 1.414L10 11.414l7.071 7.071 1.414-1.414L11.414 10l7.071-7.071-1.414-1.414L10 8.586z"
                    />
                </svg>
            </div>
        </div>
        <p v-if="error" class="mt-2 text-red-500 small">Please select a file</p>
    </div>
</template>

<script>
export default {
    props: {
        name: {
            type: String,
            required: true
        },
        required: {
            type: Boolean,
            required: true
        }
    },

    data: () => ({
        file: null,
        error: false
    }),

    computed: {
        fileName() {
            if (!this.file) return;
            return this.file.name > 20 ? `${this.file.name.slice(0, 20)}...` : this.file.name;
        }
    },

    mounted() {
        this.$refs.input.form.addEventListener('submit', this.validate);
        this.$refs.input.addEventListener('change', this.validate);
    },

    methods: {
        updateUi() {
            this.file = this.$refs.input.files[0];
        },

        validate() {
            this.error = !this.file && this.required;
        },

        reset() {
            this.$refs.input.value = '';
            this.updateUi();
        }
    }
};
</script>
<style scoped>
input:focus + div {
    outline: auto;
    outline: -webkit-focus-ring-color auto 1px;
}
</style>
